module.exports = __webpack_public_path__ + "static/media/image-loader.0ab5a87e.gif";